// @flow
import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  color: string,
  height: number,
  width: number,
};

const GreenhouseLogo = ({ color, height, width }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width}>
      <path
        fill={color}
        d="M2.096 14.689a3.423 3.423 0 0 0 3.42 3.419 3.423 3.423 0 0 0 3.419-3.42 3.423 3.423 0 0 0-3.42-3.419 3.423 3.423 0 0 0-3.419 3.42zm-1.294 0c0-2.6 2.114-4.714 4.713-4.714a4.719 4.719 0 0 1 4.714 4.714 4.72 4.72 0 0 1-4.714 4.713 4.718 4.718 0 0 1-4.713-4.713zM4.74 9.086v.25A3.942 3.942 0 0 1 .802 5.398 3.942 3.942 0 0 1 4.74 1.461a3.942 3.942 0 0 1 3.938 3.937A3.942 3.942 0 0 1 4.74 9.336v-.25zm0-6.563v.25a2.629 2.629 0 0 0-2.625 2.625A2.629 2.629 0 0 0 4.74 8.024a2.629 2.629 0 0 0 2.626-2.626A2.629 2.629 0 0 0 4.74 2.773v-.25zM6.922.78a.755.755 0 1 1 1.51 0 .755.755 0 0 1-1.51 0z"
      />
    </svg>
  );
};

GreenhouseLogo.defaultProps = {
  color: colors.mediumGrey,
  height: 20,
  width: 10,
};

export default GreenhouseLogo;
